'use client';

import { usePathname, useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';
import { useEffect } from 'react';

/**
 * 組織の TOTP 必須化ゲートで止まった利用者を、案内画面へ移す（ADR-0043 §4）。
 *
 * 業務データの API はサーバー側で止めている（403 / 503）。これは画面の誘導だけで、防御ではない。
 * `/auth/*`（ログイン・案内・紛失復旧）とプロフィールの設定画面はそのまま表示する。
 */
const ALLOWED_PREFIXES = ['/auth/', '/settings/profile'];

export function MfaGateRedirect() {
  const { data: session, status } = useSession();
  const pathname = usePathname();
  const router = useRouter();
  const gate = session?.user?.mfaGate?.status;

  useEffect(() => {
    if (status !== 'authenticated' || !gate || gate === 'ok') return;
    if (pathname && ALLOWED_PREFIXES.some((prefix) => pathname.startsWith(prefix))) return;
    router.replace(`/auth/mfa-required?reason=${gate}`);
  }, [status, gate, pathname, router]);

  return null;
}
